import { gql } from '@apollo/client';

export const ADD_DEPT = gql`
  mutation AddDept($input: DeptApiRequestInput!) {
    addDept(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export const UPDATE_DEPT = gql`
  mutation UpdateDept($input: DeptApiRequestInput!) {
    updateDept(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export const TRANSFER_DEPT = gql`
  mutation TransferDept($input: DeptApiRequestInput!) {
    transferDept(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export const DELETE_DEPT = gql`
  mutation DeleteDept($input: DeptApiRequestInput!) {
    deleteDept(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export interface DeptApiRequestInput {
  id?: number | null;
  name: string;
  parentId: number;
  warehouseList?: number[];
}
